import { render, staticRenderFns } from "./StripeCustomer.vue?vue&type=template&id=188876e2&scoped=true"
import script from "./StripeCustomer.vue?vue&type=script&lang=js"
export * from "./StripeCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188876e2",
  null
  
)

export default component.exports